import { useState, useEffect, useCallback } from 'react';
import { heroSlides } from '@/mocks/home';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prevSlide = useCallback(() => {
    setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] lg:h-[700px] overflow-hidden bg-background-50">
      {/* Slides */}
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          {/* Subtle overlay for readability */}
          <div className="absolute inset-0 bg-black/30" />
        </div>
      ))}

      {/* Text content */}
      <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center px-4">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 flex flex-col items-center justify-center transition-all duration-700 ${
              index === current
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-6 pointer-events-none'
            }`}
          >
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-wider font-heading">
              {slide.title}
            </h1>
            <p className="mt-4 md:mt-6 text-lg md:text-2xl lg:text-3xl text-white/80 font-medium tracking-wide">
              {slide.subtitle}
            </p>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        type="button"
        onClick={prevSlide}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/8 text-white/70 hover:bg-white/15 hover:text-white transition-all"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-xl md:text-2xl" />
      </button>
      <button
        type="button"
        onClick={nextSlide}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/8 text-white/70 hover:bg-white/15 hover:text-white transition-all"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-xl md:text-2xl" />
      </button>

      {/* Dots indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrent(index)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              index === current
                ? 'w-8 bg-white'
                : 'w-1.5 bg-white/30 hover:bg-white/50'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}